var map = {
  "./admin.js": "46257",
  "./classification.js": "876",
  "./feedback.js": "43251",
  "./goods.js": "88676",
  "./home.js": "4059",
  "./member.js": "45942",
  "./notification.js": "63",
  "./order.js": "46274",
  "./setting.js": "88926",
  "./stat.js": "45166",
  "./swiper.js": "48284"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33989;
